import 'Components/AppComponents/LogInPopUp/LogInPopUp.css';
import { PLAYER_DEFAULT_AGE } from 'Constants/GameData';
import { GameHelper } from 'Helpers/GameHelper';
import { useState } from 'react';
import { useEffect } from 'react';

export default function LogInPopUp({onSubmitCompletion, showPopup, G }: any) {

        const [ageSubmitted, setAgeSubmitted] = useState<any>(null);
        // const [gameData, setGameData] = useState<any>(GameHelper.getGameData());

        useEffect(() => {                
                const playerInfo = GameHelper.getPlayerInfo();
                const gameData = GameHelper.getGameData();
                const params: any = GameHelper.getQueryParamsObject({ replay: false });
                
                if (params.age || (params.eighteenplus && params.eighteenplus.toLowerCase() !== "null")) {
                        GameHelper.setPlayerInfo({...params, default: false});
                } else {
                        GameHelper.setPlayerInfo({ eighteenplus: 'no', replay: true, default: true });
                }
                
                console.log(params, playerInfo, GameHelper.checkObjectEquals({...params, replay: false}, {...playerInfo, replay: false}), gameData);
                
                if (showPopup) {
                        if((playerInfo && GameHelper.checkObjectEquals({...params, replay: false}, {...playerInfo, replay: false}) && !playerInfo.replay && gameData)) {
                                GameHelper.setGameData(G);              
                                GameHelper.updatePlayerInfo({replay: false});
                                setTimeout(() => {
                                        document.getElementById('log-in-pop-up')?.classList.add('squeeze-in');                                        
                                }, 1000);  
                        } else {
                                GameHelper.clearGameData();
                                setTimeout(() => {
                                        document.getElementById('log-in-pop-up')?.classList.add('squeeze-in');                                        
                                }, 1000);
                                // onSubmitCompletion();
                                // document.getElementById('board-container')?.classList.remove('blur-full-on');
                        }          
                }                            
        }, [showPopup]);

        // const handleSubmit = () => {
        //         if (!ageSubmitted) {  
        //                 const ageEl = document.getElementById('Age') as HTMLInputElement;
        //                 if (ageEl.value) {
        //                         document.getElementById('error-message-log-in')?.classList.add('contains-fade-right');
        //                         ageEl.parentElement?.parentElement?.classList.add('fadeOutLeft');
        //                         ageEl.parentElement!.parentElement!.parentElement!.style.minHeight = Number(ageEl.value) < 18 ? '376px' : '300px';
        //                         setTimeout(() => {
        //                                 setAgeSubmitted(Number(ageEl.value));
        //                         }, 500); 
        //                 } else {
        //                         document.getElementById('error-message-log-in')?.classList.remove('contains-fade-right');
        //                 }                        
        //         } else {
        //                 if (ageSubmitted < 18) {
        //                         const name = document.getElementById('Name') as HTMLInputElement;
        //                         const grade = document.getElementById('Grade') as HTMLInputElement;
        //                         const school = document.getElementById('School') as HTMLInputElement;
        //                         const zipCode = document.getElementById('ZipCode') as HTMLInputElement;
        //                         if (name?.value && grade?.value && school?.value && zipCode?.value) {
        //                                 document.getElementById('error-message-log-in')?.classList.add('contains-fade-right');
        //                                 document.getElementById('log-in-pop-up')?.classList.add('squeeze-out');                                      
        //                                 document.getElementById('board-container')?.classList.remove('blur-full-on');
        //                                 GameHelper.setPlayerInfo({
        //                                         age: ageSubmitted,
        //                                         name: name.value,
        //                                         grade: grade.value,
        //                                         school: school.value,
        //                                         zipCode: zipCode.value
        //                                 });
        //                                 setTimeout(() => {
        //                                         onSubmitCompletion();
        //                                 }, 1000);                                        
        //                         } else {
        //                                 document.getElementById('error-message-log-in')?.classList.remove('contains-fade-right');
        //                         }
        //                 } else {
        //                         const name = document.getElementById('Name') as HTMLInputElement;
        //                         const email = document.getElementById('Email') as HTMLInputElement;
        //                         const zipCode = document.getElementById('ZipCode') as HTMLInputElement;
        //                         if (name?.value && email?.value && zipCode?.value) {
        //                                 document.getElementById('error-message-log-in')?.classList.add('contains-fade-right');
        //                                 document.getElementById('log-in-pop-up')?.classList.add('squeeze-out');                                        
        //                                 document.getElementById('board-container')?.classList.remove('blur-full-on');
        //                                 GameHelper.setPlayerInfo({
        //                                         age: ageSubmitted,
        //                                         name: name.value,
        //                                         email: email.value,
        //                                         zipCode: zipCode.value
        //                                 });
        //                                 setTimeout(() => {
        //                                         onSubmitCompletion();
        //                                 }, 1000);                                       
        //                         } else {
        //                                 document.getElementById('error-message-log-in')?.classList.remove('contains-fade-right');
        //                         }
        //                 }
        //         }
        // }

        const continueGame = () => {
                document.getElementById('log-in-pop-up')?.classList.add('squeeze-out');                                        
                document.getElementById('board-container')?.classList.remove('blur-full-on');
                setTimeout(() => {
                        onSubmitCompletion();
                }, 1000); 
        }

        const restartGame = () => {
                GameHelper.clearGameData();
                // GameHelper.clearPlayerInfo();
                GameHelper.updatePlayerInfo({replay: true});
                window.location.reload();
        }

        
        return (<>
                <div id="log-in-pop-up" className="log-in-pop-up bg-white rounded-lg py-6 px-12 mx-12 w-1/2 duration-500 ignore-grayscale">
                        <div className="bg-pattern duration-1000" style={{ backgroundImage: `url('/images/Pattern.png')`, backgroundSize: '1150px', backgroundPosition: 'center' }}></div>
                        {GameHelper.getGameData() && <>
                                <div className="text-2xl text-center">Previous game data found.</div>
                                <div className="mt-5 flex justify-around items-center">
                                        <div className="hover-color cursor-pointer duration-100" onClick={continueGame}>Continue</div>
                                        <div className="hover-color cursor-pointer duration-100" onClick={restartGame}>Restart</div>
                                </div>
                        </>}
                        
                        {!GameHelper.getGameData() && <><div className="text-4xl text-center">Welcome { GameHelper.getPlayerInfo() && GameHelper.getPlayerInfo().fname && GameHelper.getPlayerInfo().fname.toLowerCase() !== "null"? GameHelper.getPlayerInfo().fname : '' }</div>
                                <div className="text-2xl text-center mt-2">Shall we get started?</div>
                                <div className="mt-12 flex justify-around items-center">
                                        <button onClick={continueGame} className="px-4 py-2 bg-green-400 hover:bg-green-300 rounded-md text-white" style={{textShadow: '1px 1px 3px black'}}>
                                                OK
                                        </button>
                                </div>
                                {/* <div className="mt-4 flex flex-col  duration-500" style={{ minHeight: '160px'}}>
                                        {!ageSubmitted && <div className="my-auto">
                                                <div className="text-xl flex flex-col space-y-1">
                                                        <label htmlFor="Name" >How old are you?</label>
                                                        <input
                                                                className="rounded-2xl outline-none px-3 py-2 text-center"
                                                                type="number"
                                                                // placeholder="First Name"
                                                                name="Age"
                                                                id="Age"
                                                                min="1"
                                                                style={{
                                                                background: 'linear-gradient(140deg, rgba(224, 224, 224, 0.5) 0%, rgba(160, 221, 249, 0.5) 100%)'
                                                        }} />
                                                </div>
                                        </div>}
                                        {ageSubmitted && <div className="space-y-4 fadeInRight">
                                                <div className="my-auto">
                                                        <div className="text-xl flex flex-col space-y-1">
                                                                <label htmlFor="Name" >Name</label>
                                                                <input
                                                                        className="rounded-2xl outline-none px-3 py-2"
                                                                        // placeholder="First Name"
                                                                        name="Name"
                                                                        id="Name"
                                                                        style={{
                                                                        background: 'linear-gradient(140deg, rgba(224, 224, 224, 0.5) 0%, rgba(160, 221, 249, 0.5) 100%)'
                                                                }} />
                                                        </div>
                                                </div>
                                                {ageSubmitted >= 18 && <div className="my-auto">
                                                        <div className="text-xl flex flex-col space-y-1">
                                                                <label htmlFor="Name" >Email</label>
                                                                <input
                                                                        className="rounded-2xl outline-none px-3 py-2"
                                                                        // placeholder="First Name"
                                                                        name="Email"
                                                                        id="Email"
                                                                        style={{
                                                                        background: 'linear-gradient(140deg, rgba(224, 224, 224, 0.5) 0%, rgba(160, 221, 249, 0.5) 100%)'
                                                                }} />
                                                        </div>
                                                </div>}
                                                {ageSubmitted < 18 && <>
                                                        <div className="my-auto">
                                                                <div className="text-xl flex flex-col space-y-1">
                                                                        <label htmlFor="Name" >Grade</label>
                                                                        <input
                                                                                className="rounded-2xl outline-none px-3 py-2"
                                                                                // placeholder="First Name"
                                                                                name="Grade"
                                                                                id="Grade"
                                                                                style={{
                                                                                background: 'linear-gradient(140deg, rgba(224, 224, 224, 0.5) 0%, rgba(160, 221, 249, 0.5) 100%)'
                                                                        }} />
                                                                </div>
                                                        </div>
                                                        <div className="my-auto">
                                                                <div className="text-xl flex flex-col space-y-1">
                                                                        <label htmlFor="Name" >School</label>
                                                                        <input
                                                                                className="rounded-2xl outline-none px-3 py-2"
                                                                                // placeholder="First Name"
                                                                                name="School"
                                                                                id="School"
                                                                                style={{
                                                                                background: 'linear-gradient(140deg, rgba(224, 224, 224, 0.5) 0%, rgba(160, 221, 249, 0.5) 100%)'
                                                                        }} />
                                                                </div>
                                                        </div>
                                                </>}
                                                <div className="my-auto">
                                                        <div className="text-xl flex flex-col space-y-1">
                                                                <label htmlFor="Name" >Zip Code</label>
                                                                <input
                                                                        className="rounded-2xl outline-none px-3 py-2"
                                                                        // placeholder="First Name"
                                                                        name="ZipCode"
                                                                        id="ZipCode"
                                                                        style={{
                                                                        background: 'linear-gradient(140deg, rgba(224, 224, 224, 0.5) 0%, rgba(160, 221, 249, 0.5) 100%)'
                                                                }} />
                                                        </div>
                                                </div>
                                        </div>}
                                        <div id="error-message-log-in" className="my-3 contains-fade-right duration-1000 text-sm text-red">
                                                *Please fill in all the fields
                                        </div>
                                        <div id="submit-button" className="text-center">
                                                <button onClick={handleSubmit} className="px-4 py-2 bg-green-400 hover:bg-green-300 rounded-md text-white" style={{textShadow: '1px 1px 3px black'}}>
                                                        Submit
                                                </button>
                                        </div>
                                </div> */}
                        </>}
                        
                </div>
                <style>{`

                `}</style>
        </>)
}